import { Component, OnInit, Input } from '@angular/core';
import { MenuService } from '../../services/menu.service';
export class StartPageComponent implements OnInit {

     menus: any;
     copyright: string;
/**
 * @param {?} menuService
 */
constructor(
private menuService: MenuService
    ) {}
/**
 * @return {?}
 */
ngOnInit() {
        this.menus = this.menuService.startMenu;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'hd-start-page',
  template: `
    <div class="start-menu">
        <ng-template ngFor let-menu [ngForOf]="menus" let-i="index">
            <a class="item" [routerLink]="[menu.path]" *ngIf="menu.data.isMenu">
                <img [src]="menu.data.icon">
                <span class='text'>{{menu.data.title}}</span>
                <span class='description'>{{menu.data.description}}</span>
            </a>
        </ng-template>
    </div>
    <div class='copyright'>
        <span>{{copyright}}</span>
    </div>
  `,
  styles: [`
    :host {
      background: white; }
      :host .start-menu {
        position: fixed;
        overflow-y: scroll;
        bottom: 20px;
        top: 70px;
        padding: 20px;
        -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
                flex: 1 1 auto;
        min-height: 90vh;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: start;
        text-align: center; }
        :host .start-menu .item {
          background-color: none;
          padding: 30px 20px;
          text-align: center;
          vertical-align: middle;
          width: 20%;
          text-decoration: none; }
          :host .start-menu .item .text {
            display: block;
            margin-top: 15px;
            line-height: 1.4;
            font-weight: 500;
            font-size: 16px;
            text-overflow: ellipsis;
            text-align: center;
            font-family: "Poppins";
            -ms-text-size-adjust: 100%;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            cursor: pointer;
            color: #292b3a;
            text-decoration: none; }
          :host .start-menu .item .description {
            display: block;
            line-height: 1.2;
            font-size: 12px;
            text-overflow: ellipsis;
            text-align: center;
            font-family: "Poppins";
            -ms-text-size-adjust: 100%;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            cursor: pointer;
            color: #292b3a;
            text-decoration: none; }
          :host .start-menu .item img {
            height: 70px; }
        :host .start-menu .item:hover {
          background-color: rgba(113, 106, 202, 0.1); }

    .copyright {
      position: fixed;
      bottom: 0;
      display: block;
      width: 100%;
      text-align: center;
      min-height: 5vh;
      padding: 10px;
      -webkit-box-shadow: 0 1px 15px 1px rgba(113, 106, 202, 0.1);
              box-shadow: 0 1px 15px 1px rgba(113, 106, 202, 0.1);
      background: white; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MenuService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menus': [{ type: Input },],
'copyright': [{ type: Input },],
};
}

function StartPageComponent_tsickle_Closure_declarations() {
/** @type {?} */
StartPageComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StartPageComponent.ctorParameters;
/** @type {?} */
StartPageComponent.propDecorators;
/** @type {?} */
StartPageComponent.prototype.menus;
/** @type {?} */
StartPageComponent.prototype.copyright;
/** @type {?} */
StartPageComponent.prototype.menuService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
